import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "NA_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#NA_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#093"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "NA_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#NA_svg__b)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24L32 0H0z",
      fill: "#3195F9"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M-1.012 27.094l.53.961.908-.617 34.832-23.71.702-.478-.358-.77-2.341-5.04-.492-1.056-.97.646-35.355 23.557-.766.51.445.805 2.865 5.192z",
      fill: "#E31D1C",
      stroke: "#F7FCFF",
      strokeWidth: 2
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.23 9.245L4.936 10.86l-.314-2.046-1.928.751.752-1.928L1.4 7.324 3.015 6.03 1.4 4.736l2.046-.314-.752-1.928 1.928.751.314-2.045L6.23 2.815 7.524 1.2l.314 2.045 1.928-.75-.752 1.927 2.046.314L9.445 6.03l1.615 1.294-2.046.313.752 1.928-1.928-.75-.314 2.045L6.23 9.245zm0-.715a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm2-2.5a2 2 0 11-4 0 2 2 0 014 0z",
      fill: "#FECA00"
    }
  )))
), a = t;
export {
  a as default
};
